import { Box, Checkbox, CircularProgress, Stack, Tooltip } from '@mui/material';
import { Fragment, useState } from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import { IGeopostCheckboxProps } from './interfaces/IGeopostCheckboxProps';

export const GeopostCheckbox = ({id, className, onSelect = () => {}, onUnselect =  () => {}, onChange, checked, loading, disabled = false, error = false, errorMessage = null} : IGeopostCheckboxProps) => {
    //const [selected, setSelected] = useState<boolean>(false);
    return (
        <Fragment>
            <Stack direction='row' alignItems='center'>
                <Checkbox
                    id={id}
                    className={className}
                    color="primary"
                    style={{ marginLeft: 17 }}
                    checked={checked && !error}
                    disabled={loading || disabled || error}
                    onChange={(event, checked) => {
                        if (!!onChange) {
                            onChange(checked);
                        } else {
                            if (checked) {
                                onSelect();
                            }
                            else {
                                onUnselect();
                            }
                        }
                    }
                    }
                />
                {
                    loading
                    &&
                    <Box  sx={{marginRight: '5px'}}>
                        <CircularProgress size={15}/>
                    </Box>
                }
                {
                    error
                    &&
                    <Tooltip slotProps={{popper:{sx:{zIndex:99999999999}}}} title={errorMessage}>
                        <ErrorOutlineIcon style={{cursor: 'pointer', color: 'red'}} />
                    </Tooltip>
                }
            </Stack>
        </Fragment>
    );
};